/**
 * Form class — port 1:1 din legacy common.js lines 2290-2341.
 * Subclass of FormValidator care wireaza AJAX submit catre /request endpoint.
 *
 * Integreaza si shim-ul din form-native-fix.js: daca form-ul are method=post +
 * action="...", returneaza early — submit nativ catre backend PHP (nu intercepta).
 * Asta e necesar pentru ca framework-ul nou foloseste PRG natively, nu AJAX.
 */

import { FormValidator } from './validator.js';
import { trigger } from '../core/util.js';

interface FormEvents {
    init?:        (fields: Record<string, HTMLElement | HTMLElement[]>) => void;
    valid?:       (entry: Record<string, unknown>) => Record<string, string>;
    return_true?: (entry: Record<string, unknown>) => boolean;
    done?:        (resp: number, data: unknown) => void;
}

interface FormOpts {
    submit?:     boolean;
    reset_form?: boolean;
    modal?:      boolean;
    loader?:     boolean;
}

type FormEl = HTMLFormElement;

export class Form extends FormValidator {
    constructor(target: FormEl, object: string, method: string, vars?: Record<string, unknown>, events?: FormEvents, opts?: FormOpts) {
        const mergedOpts: FormOpts = { modal: true, loader: false, ...(opts ?? {}) };
        const evts: FormEvents = events ?? {};

        const returnTrue = evts.return_true;
        const wrappedReturnTrue = (entry: Record<string, unknown>): boolean => {
            Object.assign(entry, vars ?? {});
            const rt = (window as unknown as { rt: { request: (ob: string, op: string, e: Record<string, unknown>, ev: { done: (r: number, d: unknown) => void }, o: FormOpts) => void } }).rt;
            if (typeof returnTrue === 'function') {
                if (returnTrue(entry)) {
                    rt.request(object, method, entry, {
                        done: (rs, data) => trigger(evts.done, [rs, data]),
                    }, mergedOpts);
                }
            } else {
                rt.request(object, method, entry, {
                    done: (rs, data) => trigger(evts.done, [rs, data]),
                }, mergedOpts);
            }
            return false;
        };
        evts.return_true = wrappedReturnTrue;

        super(target, evts, mergedOpts);
    }
}

/**
 * Node.prototype.Form — patch combinat cu form-native-fix.js shim.
 *
 * Daca form-ul are method=post + action="..." nevid, NU instala interceptor-ul
 * Resort (Form class). Lasa browser-ul sa submit nativ catre PHP backend (care
 * stie sa proceseze cu CSRF + redirect 303 PRG). Doar form-urile cu AJAX-only
 * legacy (fara action) primesc Form class.
 */
Node.prototype.Form = function (this: Node, object: string, method: string, vars?: Record<string, unknown>, events?: FormEvents, opts?: FormOpts) {
    const el = this as HTMLFormElement;

    // form-native-fix: bypass pentru form-uri cu method=post + action
    if (el.tagName === 'FORM' &&
        (el.getAttribute('method') ?? '').toLowerCase() === 'post' &&
        (el.getAttribute('action') ?? '') !== '') {
        return this;
    }

    new Form(el, object, method, vars, events, opts);
    return this;
} as Node['Form'];
